module.exports = __webpack_public_path__ + "components/app-store/static/google-play__qr-download-en-8da250df60ded4b0b61ce110d2bae657.svg";